module.exports = __webpack_public_path__ + "img/clube3.f35c842e.jpeg";